<template>
  <div>
    <a-space>
      <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
      <vxe-input v-model="query['order.no']" placeholder="placeholder.receiptOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['customer.name']" placeholder="business.label.customerName" @clear="refresh" @keydown.native.enter="refresh"/>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('business.label.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('business.label.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
    </a-space>
    <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
      <vxe-column field="customer.name" title="business.label.customerName"/>
      <vxe-column field="asnOrder.orderStatus" title="business.label.orderStatus" width="100">
        <template slot-scope="{ row }">{{ orderStatusData.length === 0 ? row.asnOrder.orderStatus : orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name }}</template>
      </vxe-column>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
    <shelf-task ref="shelfTask" :scroll-y="taskScrollY"/>
  </div>
</template>

<script>
import moment from 'moment'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import { findAll, findEnum } from '@/api/Api'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { getOptions } from '@/utils/util'

export default {
    name: 'ShelfByOrder',
    components: {ShelfTask, PageUtil},
    data() {
      return {
        data: [],
        owners: [],
        orderStatusData: [],
        contentSize: 0,
        page: 1,
        size: 5,
        loading: false,
        query: {
          'order.no': '',
          'customer.name': '',
          'owner.id': undefined,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        },
        args: null,
        taskScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.48)
      }
    },
  created() {
      findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
        if (res.success) {
          this.owners = getOptions(res.result)
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      disabledStartDate(startValue) {
        const endValue = this.query.dateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.dateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.fetch()
      },
      rowClick(row) {
        this.$refs.shelfTask.getData({'order.no': row.order.no})
      },
      moment,
      fetch() {
        this.loading = true
        let args = Object.assign({}, this.query)
        if (args.dateFilter.start === null && args.dateFilter.end === null) {
          args.dateFilter = null
        }
        findAll('receivingReceiptListFactory', args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            this.$refs.shelfTask.reset()
          }
        }).finally(() => this.loading = false)
      },
      refresh() {
        this.page = 1
        this.fetch()
      },
      reset() {
        this.page = 1
        this.size = 5
        this.contentSize = 0
        this.query = {
          'order.no': '',
          'customer.name': '',
          'owner.id': undefined,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        }
        this.fetch()
      },
      confirm() {
        this.$refs.shelfTask.putaway()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }
</style>